/**
 * CR-8675: the Recent Jobs From/To date filter.
 *
 * The inputs hold calendar days (YYYY-MM-DD) in the viewer's own time zone.
 * The job lists filter on `created_after` / `created_before`, both inclusive,
 * so From becomes the start of its day and To the end of its day — sent as
 * ISO instants, so "29 Oct" means the viewer's 29 Oct, not UTC's.
 */
export interface DateRange {
  from: string;
  to: string;
}

export const EMPTY_DATE_RANGE: DateRange = { from: '', to: '' };

function localDay(day: string, endOfDay: boolean): string {
  const [y, m, d] = day.split('-').map(Number);
  const date = endOfDay
    ? new Date(y, m - 1, d, 23, 59, 59, 999)
    : new Date(y, m - 1, d, 0, 0, 0, 0);
  return date.toISOString();
}

/** Query params for the job lists; empty bounds are left out. */
export function dateRangeParams(range: DateRange): { created_after?: string; created_before?: string } {
  return {
    ...(range.from ? { created_after: localDay(range.from, false) } : {}),
    ...(range.to ? { created_before: localDay(range.to, true) } : {}),
  };
}

export function hasDateRange(range: DateRange): boolean {
  return Boolean(range.from || range.to);
}
